<template>
  <div class="container mescroll-touch">
    <div class="navigationBar">
      <div class="nav-left">
        <img @click="goback" src="@/assets/images/back_icon.png" />
      </div>
      <div class="nav-title">{{ title }}</div>
      <div class="nav-right" @click="generatePoster">
        <img src="@/assets/images/share_icon1.png" />
      </div>
    </div>
    <div class="details" :style="{ backgroundImage: `url(${bg ? bg : ''})`}">
      <div class="moduleBox" v-for="module in moduleList" :key="module.Id">
        <div class="titleBox" v-if="module.Title && module.Type != 6 && !module.IsNew">{{ module.Title }}</div>
        <div class="titleBox1" v-if="(module.Title && module.IsNew) || (module.Type == 6 && module.List.length > 0)">
          <div class="title">
            <img class="title_icon" :src="module.iconFileList[0] ? module.iconFileList[0].url : ''" />
            <span>{{ module.Title }}</span>
          </div>
          <div class="more" @click="viewMore(module.Id)">
            <span>查看更多</span>
            <van-icon class="arrow" name="arrow" />
          </div>
        </div>
        <!-- 轮播图 -->
        <div class="swipeBox" v-if="module.Type == 1 && module.List.length > 0">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#EB1700">
            <van-swipe-item v-for="item in module.List" :key="item.Id" @click="bannerClick(item)">
              <img class="banner" :src="item.FileUrl" alt="" srcset="">
            </van-swipe-item>
          </van-swipe>
        </div>

        <!-- 富文本框 -->
        <div class="richtextBox" v-if="module.Type == 2" v-html="module.UeditorContent"></div>

        <!-- 横版内容 -->
        <div class="horizontalBox" v-if="module.Type == 3 && module.List.length > 0">
          <swiper class="horizontalSwiper" ref="horizontalSwiper" :options="swiperOptions" @click="(event) => handleSwiperClick(event, module.List)">
            <swiper-slide v-for="item in module.List" :key="item.Id">
              <img :src="item.FileUrl" alt="" srcset="">
            </swiper-slide>
          </swiper>
          <div class="viewMore" v-if="module.IsMore && !module.IsNew" @click="viewMore(module.Id)">查看更多<van-icon name="arrow" /></div>
        </div>

        <!-- 竖版双排 -->
        <div class="doubleRowList" v-if="module.Type == 4 && module.ArrangeType == 2 && module.List.length > 0">
          <div class="list">
            <div class="listItem" v-for="(item, index) in module.List" :key="index" @click="contentClick(item)">
              <img class="cover" :src="item.FileUrl" />
              <div class="info">
                <p class="title van-multi-ellipsis--l2">{{ item.Title }}</p>
                <p class="time" v-if="item.ArtType == 3">{{ item.StratTime }}</p>
                <div class="doctorInfo" v-if="item.SpeakerName">
                  <img src="@/assets/images/headSculpture1.png" />
                  <span class="doctorName">{{ item.SpeakerName }}</span>
                  <span class="hospital van-ellipsis">{{ item.SpeakerHospital }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="viewMore" v-if="module.IsMore && !module.IsNew" @click="viewMore(module.Id)">查看更多<van-icon name="arrow" /></div>
        </div>

        <!-- 竖版单排 -->
        <div class="singleRowList" v-if="module.Type == 4 && module.ArrangeType == 1 && module.List.length > 0">
          <div class="listItem" v-for="(item, index) in module.List" :key="index" @click="contentClick(item)">
            <img class="cover" :src="item.FileUrl" />
            <div class="info">
              <p class="title van-ellipsis">{{ item.Title }}</p>
            </div>
          </div>
          <div class="viewMore" v-if="module.IsMore && !module.IsNew" @click="viewMore(module.Id)">查看更多<van-icon name="arrow" /></div>
        </div>
        
        <!-- 金刚区 -->
        <div class="iconBox" v-if="module.Type == 5 && module.List.length > 0">
          <div class="iconItem" v-for="(item, index) in module.List" :key="index" @click="columnsClick(item)">
            <img :src="item.FileUrl" />
            <span>{{item.Title}}</span>
          </div>
        </div>

        <!-- 近期活动 -->
        <div class="recentActivitiesWrapper" v-if="module.Type == 6 && module.List.length > 0">
          <div class="recentActivitiesList">
            <div class="recentActivitiesItem" v-for="(item, index) in module.List" :key="index" @click="contentClick(item)">
              <div class="activitieCover">
                <img :src="item.FileUrl" />
                <div class="activitieStatus liveStreaming" v-if="item.LiveStatus == 1">
                  <img src="@/assets/images/live1.png" />
                  <span>进行中</span>
                </div>
                <div class="activitieStatus notStartedLive" v-if="item.LiveStatus == 2">
                  <img src="@/assets/images/notStartedLive.png" />
                  <span>即将开始</span>
                </div>
                <div class="activitieStatus noLive" v-if="item.LiveStatus == 3">
                  <img src="@/assets/images/notLive.png" />
                  <span>已结束</span>
                </div>
              </div>
              <div class="activitieInfo">
                <p class="activitieTitle van-multi-ellipsis--l2">{{ item.Title }}</p>
                <p class="activitieTime" v-if="item.StratTime">开始时间：{{ item.StratTime.replace(/:\d{2}$/, '') }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 专区 -->
        <div class="zoneBox" v-if="module.Type == 7 && module.List.length > 0">
          <img class="zoneTheme" :src="module.fileList[0] ? module.fileList[0].url : ''" />
          <div class="zoneContent">
            <div class="zoneItem" v-for="(item, index) in module.List" :key="index" @click="productClick(item)">
              <img class="cover" :src="item.FileUrl" />
              <div class="zoneTitle" v-if="item.Title">
                <span>{{ item.Title }}</span>
                <van-icon class="arrow" name="arrow" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="noMore" v-if="moduleList.length > 0">没有更多了</div>
    </div>
    <van-popup class="PosterPopup" v-model="PosterShow" :close-on-click-overlay="false" @opened="generateImageOpened">
        <div class="close" @click="PosterShow = false">
          <van-icon class="closeIcon" name="cross" />
        </div>
        <div class="PosterBox">
          <div class="generateImageBox" ref="generateImageBox" v-if="!PosterPhoto">
            <img class="PosterImg" v-if="cover" :src="cover" />
            <div class="QrcodeBox">
              <img class="QrcodeFont" src="@/assets/images/font1.png" />
              <img class="Qrcode" crossOrigin="anonymous" v-if="QRCode" :src="QRCode" />
              <img class="QrcodeFont" src="@/assets/images/font2.png" />
            </div>
          </div>
          <img class="PosterPhoto" v-else :src="PosterPhoto" alt="">
          <p class="tips">请长按保存图片到手机后转发</p>
        </div>
    </van-popup>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import html2canvas from 'html2canvas';
import BScroll from 'better-scroll'
import mixin from '../../common/mixin/mixins'
import { mapState } from "vuex";
export default {
  name: 'ZoneDetails',
  data() {
    return {
      hasPath: '',
      title: '',
      moduleList: [],
      bg: '',
      swiperOptions: {
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: true,
        simulateTouch: true,
        touchRatio: 1,
        speed: 500,
        effect: 'slide',
        slideToClickedSlide: true,
      },
      PosterShow: false,
      cover: '',
      QRCode: '',
      PosterPhoto: '',
      recentActivitiesScrolls: [] // 多个近期活动横向滚动实例
    }
  },
  mixins: [mixin],
  computed: {
    ...mapState(["userInfo"]),
    id() {
      return this.$route.query.id
    },
    sourceType() {
      return this.$route.query.sourceType
    },
    sourceId() {
      return this.$route.query.sourceId
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if(from.path == '/') {
        vm.hasPath = from.path;
      }
    });
  },
  created() {
    // this.getZoneDetails();
  },
  activated() {
    this.getZoneDetails();
    this.enter();
  },
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.destroyRecentActivitiesBScroll();
  },
  methods: {
    // 初始化多个"近期活动"横向滚动
    initRecentActivitiesBScroll() {
      this.$nextTick(() => {
        const wrappers = this.$el.querySelectorAll('.recentActivitiesWrapper');
        this.recentActivitiesScrolls = Array.from(wrappers).map((el) => {
          return new BScroll(el, {
            startX: 0,
            click: true,
            scrollX: true,
            scrollY: false,
            eventPassthrough: 'vertical'
          });
        });
      });
    },
    // 列表数据变化后重新计算滚动范围
    refreshRecentActivitiesBScroll() {
      this.$nextTick(() => {
        this.recentActivitiesScrolls.forEach((scroll) => scroll.refresh());
      });
    },
    destroyRecentActivitiesBScroll() {
      this.recentActivitiesScrolls.forEach((scroll) => scroll.destroy());
      this.recentActivitiesScrolls = [];
    },
    enter() {
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: 0,
        ZDId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        type: 1,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {
        if (!this.timer && res.Data != 0) {
          this.timer = setInterval(() => {
            this.$axios.post("/Api/Api/Web/Article/ABUpdateTime?id=" + res.Data).then(() => {});
          }, 10000);
        }
      });
    },
    getZoneDetails() {
      let toast = this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      this.$axios.post('/Api/Api/Web/Zone/GetZD', {
        ZDId: this.id
      }).then(res => {
        let data = res.Data;
        this.title = data.Title;
        this.QRCode = data.QrCode;
        this.moduleList = data.zd ? data.zd : [];
        const firstBanner = this.moduleList.find(item => item.Type == 1);
        if(firstBanner && firstBanner.List.length > 0) {
          this.cover = firstBanner.List[0].FileUrl;
        } else {
          this.cover = require('@/assets/images/cover.jpg');
        }

        const firstIcon = this.moduleList.find(item => item.Type === 5);
        if(firstIcon && firstIcon.fileList.length > 0) {
          this.bg = firstIcon.fileList[0].url;
        }

        this.initRecentActivitiesBScroll();

        wx.miniProgram.postMessage({
          data: {
            share: {
              title: this.title,
              imageUrl: '',
              path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/zoneDetails?id=${this.$route.query.id}&sourceType=7`)}`,
              contentId: ''
            }
          }
        })

        toast.clear();
      });
    },
    bannerClick(info) {
      if(info.LinkType && info.LinkUrl) {
        this.BuriedPoint(3, info.Title ? info.Title : '', '', this.$route.fullPath.replace(/&stack-key=[^&]*/, ''));
        if(info.LinkType == 1) {
          let objExp=new RegExp(/^(f|ht)tps?:\/\//i);
          if(objExp.test(info.LinkUrl)) {
            location.href = info.LinkUrl;
          } else {
            this.$router.push(info.LinkUrl);
          }
        } else if(info.LinkType == 2) {
          wx.miniProgram.navigateTo({url: info.LinkUrl})
        } else if(info.LinkType == 3) {
          if (info.LinkUrl.indexOf('?') !== -1) {
            info.LinkUrl += '&sourceType=13&sourceId=' + info.Id;
          } else {
            info.LinkUrl += '?sourceType=13&sourceId=' + info.Id;
          }
          this.$router.push(info.LinkUrl);
        }
      }
    },
    columnsClick(info) {
      if(info.LinkType && info.LinkUrl) {
        this.BuriedPoint(1, info.Title ? info.Title : '', '', this.$route.fullPath.replace(/&stack-key=[^&]*/, ''));
        if(info.LinkType == 1) {
          let objExp=new RegExp(/^(f|ht)tps?:\/\//i);
          if(objExp.test(info.LinkUrl)) {
            location.href = info.LinkUrl;
          } else {
            this.$router.push(info.LinkUrl);
          }
        } else if(info.LinkType == 2) {
          wx.miniProgram.navigateTo({url: info.LinkUrl})
        } else if(info.LinkType == 3) {
          if (info.LinkUrl.indexOf('?') !== -1) {
            info.LinkUrl += '&sourceType=14&sourceId=' + info.Id;
          } else {
            info.LinkUrl += '?sourceType=14&sourceId=' + info.Id;
          }
          this.$router.push(info.LinkUrl);
        }
      }
    },
    contentClick(info) {
      if(info.Type == 1 && info.LinkUrl) {
        if (/^https?:\/\//i.test(info.LinkUrl)) {
          location.href = info.LinkUrl;
        } else {
          this.$router.push(info.LinkUrl);
        }
      } else if (info.Type == 2) {
        if(info.ArtType == 1 || info.ArtType == 2) {
          this.$router.push({
            path: 'contentPage',
            query: {
              id: info.ArtId,
              type: info.ArtType,
              sourceType: 12,
              sourceId: this.id
            }
          });
        } else if(info.ArtType == 3) {
          this.$router.push({
            path: 'liveDetails',
            query: {
              id: info.ArtId,
              sourceType: 12,
              sourceId: this.id
            }
          });
        } else if(info.ArtType == 4) {
          this.$router.push({
            path: 'activityDetails',
            query: {
              id: info.ArtId,
              sourceType: 12,
              sourceId: this.id
            }
          });
        }
      }
    },
    productClick(info) {
      if(info.LinkType && info.LinkUrl) {
        this.BuriedPoint(1, info.Title ? info.Title : '', '', this.$route.fullPath.replace(/&stack-key=[^&]*/, ''));
        if(info.LinkType == 1) {
          let objExp=new RegExp(/^(f|ht)tps?:\/\//i);
          if(objExp.test(info.LinkUrl)) {
            location.href = info.LinkUrl;
          } else {
            this.$router.push(info.LinkUrl);
          }
        } else if(info.LinkType == 2) {
          wx.miniProgram.navigateTo({url: info.LinkUrl})
        } else if(info.LinkType == 3) {
          if (info.LinkUrl.indexOf('?') !== -1) {
            info.LinkUrl += '&sourceType=17&sourceId=' + info.Id;
          } else {
            info.LinkUrl += '?sourceType=17&sourceId=' + info.Id;
          }
          this.$router.push(info.LinkUrl);
        }
      }
    },
    goback() {
      if(this.hasPath == '/' ) {
        this.$router.push('/home');
        return;
      }
      this.$router.go(-1);
    },
    handleSwiperClick(swiper, list) {
      const realIndex = swiper.realIndex
      console.log(realIndex, list);
      if(list[realIndex].Type == 1 && list[realIndex].LinkUrl) {
        if (/^https?:\/\//i.test(list[realIndex].LinkUrl)) {
          location.href = list[realIndex].LinkUrl;
        } else {
          this.$router.push(list[realIndex].LinkUrl);
        }
      } else if (list[realIndex].Type == 2) {
        if(list[realIndex].ArtType == 1 || list[realIndex].ArtType == 2) {
          this.$router.push({
            path: 'contentPage',
            query: {
              id: list[realIndex].ArtId,
              type: list[realIndex].ArtType,
              sourceType: 12,
              sourceId: this.id
            }
          });
        } else if(list[realIndex].ArtType == 3) {
          this.$router.push({
            path: 'liveDetails',
            query: {
              id: list[realIndex].ArtId,
              sourceType: 12,
              sourceId: this.id
            }
          });
        } else if(list[realIndex].ArtType == 4) {
          this.$router.push({
            path: 'activityDetails',
            query: {
              id: list[realIndex].ArtId,
              sourceType: 12,
              sourceId: this.id
            }
          });
        }
      }
    },
    viewMore(moduleId) {
      this.$router.push({
        path: 'zoneMoreList',
        query: {
          zoneDetailsId: this.id,
          id: moduleId
        }
      });
    },
    generatePoster() {
      this.imageUrls = this.cover;
      this.PosterShow = true;
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: 0,
        ZDId: this.id,
        CustomerId: this.userInfo.Id,
        Type: 11,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {});
    },
    generateImageOpened() {
      let toast = this.$toast.loading({
        message: '生成中...',
        forbidClick: true,
      });
      
      // 等待所有图片加载完成
      this.$nextTick(async () => {
        const images = this.$refs.generateImageBox.querySelectorAll('img');
        const imagePromises = Array.from(images).map(img => {
          return new Promise((resolve) => {
            if (img.complete && img.naturalHeight !== 0) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = resolve; // 即使出错也继续
            }
          });
        });
        
        try {
          // 等待所有图片加载（或出错）
          await Promise.all(imagePromises);
          
          // 给一个延迟确保 DOM 稳定
          await new Promise(resolve => setTimeout(resolve, 500));
          
          html2canvas(this.$refs.generateImageBox, {
            useCORS: true,
            allowTaint: true, // 允许 tainted canvas
            backgroundColor: null, // 透明背景
            scale: 2, // 提高清晰度
          }).then((canvas) => {
            this.PosterPhoto = canvas.toDataURL("image/png");
            toast.clear();
          }).catch(error => {
            console.error('html2canvas 错误:', error);
            toast.clear();
            this.$toast('生成海报失败，请重试');
          });
          
        } catch (error) {
          toast.clear();
          console.error('图片等待错误:', error);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #F9F9F9;
}
.navigationBar {
  display: flex;
  align-items: center;
  height: 52px;
  box-sizing: border-box;
  background-color: #EB1700;
  color: #FFFFFF;
  padding: 0 15px;
  .nav-left {
    img {
      display: block;
      width: 9px;
    }
  }
  .nav-title {
    flex: 1;
    font-size: 17px;
    font-weight: 600;
    // font-weight: bold;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .nav-right {
    img {
      display: block;
      width: 19px;
    }
  }
}
.details {
  flex: 1;
  padding: 16px 0 0;
  overflow: auto;
  // background: url('../../assets/images/zone_bg.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-attachment: local;
  .moduleBox {
    .titleBox {
      height: 35px;
      line-height: 35px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      color: #FFFFFF;
      background: url('../../assets/images/title_bg.png');
      background-size: 100% 100%;
      margin: 0 15px 16px;
    }
    .titleBox1 {
      height: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 15px 16px;
      .title {
        display: flex;
        align-items: center;
        font-size: 13px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
        .title_icon {
          display: block;
          width: 16px;
          margin-right: 5px;
        }
      }
      .more {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
        margin-right: 5px;
        .arrow {
          font-size: 12px;
          font-weight: bold;
          color: #EB1700;
          margin-left: 4px;
        }
      }
    }
    .swipeBox {
      margin: 0 12px 25px;
      border-radius: 12px;
      overflow: hidden;
      .banner {
        display: block;
        width: 100%;
      }
      /deep/ .van-swipe__indicators {
        bottom: 8px !important;
      }
      /deep/ .van-swipe__indicator {
        background-color: #FFFFFF !important;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.08) !important;
      }
      /deep/ .van-swipe__indicator--active {
        background-color: #EB1700 !important;
      }
    }
    .richtextBox {
      margin: 0 15px 24px;
    }
    /deep/ .richtextBox > p > img {
      width: 100%;
    }
    /deep/ .richtextBox img {
      width: 100%;
    }
    .horizontalBox {
      margin-bottom: 24px;
      overflow: hidden;
    }
    .horizontalSwiper {
      padding: 0 15px;
      overflow: visible;
      ::-webkit-scrollbar {
        display: none;
      }
      ::v-deep .swiper-slide {
        width: 60%;
        margin: 0 auto;
        transition: transform 0.3s, opacity 0.3s;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 4px 0px;
        border-radius: 12px;
        img {
          display: block;
          width: 100%;
          object-fit: cover;
          border-radius: 12px;
        }
      }
      ::v-deep .swiper-slide:not(.swiper-slide-active) {
        transform: scale(0.9);
      }
    }
    .doubleRowList {
      margin: 0 15px 24px;
      .list {
        // display: flex;
        // flex-wrap: wrap;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 10px; /* 间距统一 */
        .listItem {
          display: flex;
          flex-direction: column;
          // width: calc(calc(100% / 2) - 5px);
          background-color: #FFFFFF;
          border-radius: 10px;
          overflow: hidden;
          .cover {
            display: block;
            width: 100%;
          }
          .info {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .title {
              font-size: 12px;
              color: #3D3D3D;
              padding: 0 5px;
              margin: 5px 0;
            }
            .time {
              font-size: 10px;
              color: #999999;
              margin: 0 5px 5px;
            }
            .doctorInfo {
              display: flex;
              align-items: flex-start;
              font-size: 10px;
              line-height: 14px;
              border-top: 1px solid #F4F4F4;
              padding: 5px;
              img {
                display: block;
                width: 18px;
                margin-right: 4px;
              }
              span {
                color: #979797;
              }
            }
          }
        }
        // .listItem:not(:nth-last-child(-n+2)) {
        //   margin-bottom: 10px;
        // }
        // .listItem:nth-child(even) {
        //   margin-left: 10px;
        // }
      }
    }
    .singleRowList {
      margin: 0 15px 15px;
      .listItem {
        position: relative;
        border-radius: 12px;
        overflow: hidden;
        .cover {
          display: block;
          width: 100%;
        }
        .info {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 30px 10px 10px;
          background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
          color: #FFFFFF;
          .title {
            font-size: 12px;
            text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
          }
        }
      }
      .listItem:not(:last-of-type) {
        margin-bottom: 10px;
      }
    }
    .viewMore {
      font-size: 12px;
      color: #EB1701;
      text-align: center;
      margin-top: 8px;
    }
    .iconBox {
      display: flex;
      margin: 0px 15px 24px;
      .iconItem {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        flex: 1;
        text-align: center;
        img {
          display: block;
          margin: 0 auto;
          width: 46px;
        }
        span {
          font-size: 12px;
          color: #3D3D3D;
          margin-top: 3px;
        }
      }
    }
    .recentActivitiesWrapper {
      margin-bottom: 24px;
      overflow: hidden;
      .recentActivitiesList {
        display: inline-flex;
        flex-wrap: nowrap;
        min-width: 100%;
        .recentActivitiesItem {
          display: flex;
          flex-shrink: 0;
          width: 314px;
          background-color: #FFFFFF;
          padding: 2px;
          border-radius: 6px;
          margin-right: 8px;
          .activitieCover {
            position: relative;
            width: 140px;
            border-radius: 6px;
            overflow: hidden;
            img {
              display: block;
              width: 100%;
            }
            .activitieStatus {
              display: flex;
              align-items: center;
              position: absolute;
              left: 5px;
              bottom: 5px;
              height: 15px;
              border-radius: 15px;
              padding: 0 5px;
              font-size: 9px;
              img {
                display: block;
                width: 9px;
                margin-right: 2px;
              }
            }
            .noLive {
              background-color: #D8D8D8;
              color: #000000;
            }
            .liveStreaming {
              background-color: #EB1700;
              color: #FFFFFF;
            }
            .notStartedLive {
              background-color: #FCEDED;
              color: #EB1700;
            }
          }
          .activitieInfo {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex: 1;
            padding: 8px;
            .activitieTitle {
              font-size: 12px;
              color: #000000;
            }
            .activitieTime {
              font-size: 11px;
              color: #999999;
            }
          }
        }
        .recentActivitiesItem:first-of-type {
          margin-left: 15px;
        }
        .recentActivitiesItem:last-of-type {
          margin-right: 15px;
        }
      }
    }
    .zoneBox {
      margin-bottom: 24px;
      .zoneTheme {
        display: block;
        width: 100%;
      }
      .zoneContent {
        margin: 0 15px;
        display: flex;
        .zoneItem {
          position: relative;
          flex: 1;
          border-radius: 8px;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
          border: 1px solid rgba(255, 255, 255, 0.8);
          box-sizing: border-box;
          overflow: hidden;
          .cover {
            display: block;
            width: 100%;
          }
          .zoneTitle {
            position: absolute;
            left: 10px;
            right: 15px;
            bottom: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            color: #EB1700;
            .arrow {
              font-weight: bold;
            }
          }
        }
        .zoneItem:not(:last-of-type) {
          margin-right: 8px;
        }
      }
    }
  }
  .noMore {
    font-size: 12px;
    color: #CCCCCC;
    text-align: center;
    margin-bottom: 20px;
  }
}

.PosterPopup {
  width: 90%;
  height: 350px;
  border-radius: 14px;
  overflow-y: visible;
}
.close {
  position: absolute;
  top: -7px;
  right: -7px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  background-image: linear-gradient(130deg, #EB1700 50%, #C33BBB 80%, #8C3BBB 100%);
  z-index: 99;
  .closeIcon {
    color: #FFFFFF;
  }
}
.PosterBox {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  border-radius: 14px;
  .generateImageBox {
    padding-bottom: 10px;
  }
  .PosterImg {
    display: block;
    width: 100%;
  }
  .QrcodeBox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    .QrcodeFont {
      width: 60px;
    }
  }
  .Qrcode {
    display: block;
    width: 100px;
    margin: 0 30px ;
  }
  .PosterPhoto {
    display: block;
    width: 100%;
  }
  .tips {
    font-size: 13px;
    color: #333333;
    margin: 0 0 18px;
    text-align: center;
  }
}
</style>